export const FETCH_PODCAST_PLATFORMS_REQUEST = "FETCH_PODCAST_PLATFORMS_REQUEST";
export const FETCH_PODCAST_PLATFORMS_SUCCESS = "FETCH_PODCAST_PLATFORMS_SUCCESS";
export const FETCH_PODCAST_PLATFORMS_FAILURE = "FETCH_PODCAST_PLATFORMS_FAILURE";
